<template>
  <checker-view :title="title" type="licence" :itemMap="itemMap" :getData="getData" :confirm="true" @cleared="clear">
    <template slot="form">
      <div v-if="useNum">
        <edit-field
          label="Licence Number" icon="verified_user" v-model="model.number"/>
        <a @click="useNum = false">Forgot your licence number?</a>
      </div>
      <div v-else id="extras">
        <edit-field label="Full Name" icon="person" v-model="model.name"/>
        <google-autocomplete v-model="model.address"/>
        <a @click="useNum = true">Back to use my licence number</a>
      </div>
      <date-field label="Date of Birth*" v-model="model.birthdate"/>
      <edit-field
        label="Mobile Number" icon="smartphone"
        v-model="model.mobile" validation="required|digits:10|begins:04"/>
    </template>
  </checker-view>
</template>

<script>
import GoogleAutocomplete from '@/components/google-autocomplete'
import CheckerView from '@/components/checker'
import DateField from '@/components/date-field'
import EditField from '@/components/edit-field'
import { bool, date, title } from '@/filters'

export default {
  components: { GoogleAutocomplete, CheckerView, DateField, EditField },
  inject: ['$validator'],
  data () {
    return {
      title: 'MAST Online Motor Boat Licence Check',
      useNum: true,
      model: {
        number: '',
        address: '',
        name: '',
        birthdate: '',
        mobile: ''
      },
      autocomplete: null
    }
  },
  methods: {
    itemMap: (item) => ({
      'Licence Number': item.key,
      'Expiry': date(item.expiry_date),
      'Owner': title(item.owner.full_name),
      'Visual Aids': title(bool(item.has_visual_aids)),
      'PWC Endorsement': title(bool(item.has_pwc_endorsement)),
      'Provisional': title(bool(item.is_provisional))
    }),
    clear () {
      this.model.number = ''
      this.model.address = ''
      this.model.name = ''
      this.model.birthdate = ''
      this.model.mobile = ''
      this.useNum = true
    },
    getData () {
      return Object.entries(this.model)
        .filter(([k, v]) => v !== '')
        .reduce((acc, [k, v]) => Object.assign(acc, {[k]: v}), {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/licence.vue